import React from 'react';
import {useRef} from 'react';
import * as api from '../../api';
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { ValidateEventDates } from '../../utils/ValidateEvent';
import CustomEditor from '../TextEditor/CustomEditor';


const CreateEventAdminPanel = (props) => {

    const navigate = useNavigate();
    const [searchparams] = useSearchParams();
    const title_fr_ref = useRef(null);
    const title_en_ref = useRef(null);
    // const description_fr_ref = useRef(null);
    // const description_en_ref = useRef(null);
    const localisation_ref = useRef(null);
    const main_date_ref = useRef(null);
    const online_date_ref = useRef(null);
    const am_or_pm_ref = useRef(null);
    const inscriptions_start_date_ref = useRef(null);
    const inscriptions_end_date_ref = useRef(null);
    const logo_path_ref = useRef(null);
    const image_path_ref = useRef(null);

    const [descFR, setDescFR] = React.useState("")
    const [descEN, setDescEN] = React.useState("")

    async function handlePublish() {
        console.log('trying to publish');

        const newEvent = new FormData();
        newEvent.append("type", searchparams.get("type"));
        newEvent.append("title_fr", title_fr_ref.current.value);
        newEvent.append("title_en", title_en_ref.current.value);
        // newEvent.append("description_fr", description_fr_ref.current.value);
        // newEvent.append("description_en", description_en_ref.current.value);
        newEvent.append("description_fr", descFR);
        newEvent.append("description_en", descEN);
        newEvent.append("localisation", localisation_ref.current.value);
        newEvent.append("main_date", main_date_ref.current.value);
        newEvent.append("online_date", online_date_ref.current.value);
        newEvent.append("am_or_pm", am_or_pm_ref.current.value);
        newEvent.append("inscriptions_start_date", inscriptions_start_date_ref.current.value);
        newEvent.append("inscriptions_end_date", inscriptions_end_date_ref.current.value);
        newEvent.append("logo_path", logo_path_ref.current.files[0]);
        newEvent.append("image_path", image_path_ref.current.files[0]);

        if(!ValidateEventDates({main_date:main_date_ref.current.value,online_date:online_date_ref.current.value,inscriptions_start_date:inscriptions_start_date_ref.current.value,inscriptions_end_date:inscriptions_end_date_ref.current.value})){
            alert("Dates invalides")
            return
        }

        api.createEvent(newEvent).then(res => {
            console.log(res);
            navigate("/admin/events")
        }).catch(err => {
            console.log(err);
            alert("erreur");
        });
    }

    return (
        <div>
            <span className='linkbutton' ><Link to="/admin/events">← Retour au panneau d'administration</Link></span><br/>
            <br/>
            <h1 className='centered'>Créer un événement {searchparams.get("type")}</h1>
            <br/>
            <div className='dualInput'>
                <label>
                    Nom du speed dating FR :<br/>
                    <input required type="text" ref={title_fr_ref} />
                </label>
                <label>
                    Nom du speed dating EN :<br/>
                    <input required type="text" ref={title_en_ref} />
                </label>
            </div>
            Description FR :<br/><br/>
            <CustomEditor 
                value={descFR}
                onChange={setDescFR}
            />
            <br/><br/>
            Description EN :<br/><br/>
            <CustomEditor 
                value={descEN}
                onChange={setDescEN}
            />
            <br/><br/>
            <label>
                Localisation :
                <input required type="text" ref={localisation_ref} />
            </label>
            <br/>
            <div className='dualInput'>
                <label>
                    Date de l'évenement en physique :<br/>
                    <input required type="date" ref={main_date_ref} />
                </label>
                <label>
                    Date de l'évenement en ligne :<br/>
                    <input required type="date" ref={online_date_ref} />
                </label>
            </div>
            <br/>
            <label>
                Horaires de l'évenement :<br/>
                <select ref={am_or_pm_ref}>
                    <option value="am">Matin</option>
                    <option value="pm">Après-midi</option>
                </select>
            </label>
            <br/>
            <div className='dualInput'>
                <label>
                    Date de début des inscriptions :<br/>
                    <input required type="date" ref={inscriptions_start_date_ref} />
                </label>
                <label>
                    Date de fin des inscriptions :<br/>
                    <input required type="date" ref={inscriptions_end_date_ref} />
                </label>
            </div>
            <div className='dualInput'>
                <label>
                    Logo (obligatoire) :<br/>
                    <input required type="file" ref={logo_path_ref} />
                </label>
                <label>
                    Visuel (obligatoire) :<br/>
                    <input required type="file" ref={image_path_ref} />
                </label>
            </div>
            <br/>
            <button className='centered' onClick={handlePublish}>Enregistrer</button>
            <br/>
            <p className='centered'>Vous devez d'abord enregistrer l'événement pouvoir le prévisualiser</p>
        </div>
    );
};


export default CreateEventAdminPanel;